export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9023.8e77c3a7.jpg";